import React from 'react';

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-white py-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col md:flex-row justify-between items-center gap-8">
          <div className="text-center md:text-left">
            <h2 className="text-3xl font-bold text-white mb-2">Ribyte</h2>
            <p className="text-gray-400">Soluciones tecnológicas para el mundo empresarial.</p>
          </div>
          
          <div className="flex space-x-8">
            <button className="text-gray-400 hover:text-white transition-colors cursor-pointer">Privacidad</button>
            <button className="text-gray-400 hover:text-white transition-colors cursor-pointer">Términos</button>
            <button className="text-gray-400 hover:text-white transition-colors cursor-pointer">Contacto</button>
          </div>
        </div>
        
        <div className="mt-12 pt-8 border-t border-gray-800 text-center text-gray-500 text-sm">
          &copy; {new Date().getFullYear()} Ribyte Solutions. Todos los derechos reservados.
        </div>
      </div>
    </footer>
  );
};

export default Footer;
